import Vue from 'vue'
import PurchaseOrderTransformer from '@/transformers/purchase/purchaseOrdersSupplies'


export default (camp) => Vue.$http.get(`purchase/list_orders_without_freight/${camp}/`)
    .then((response) => {
      const data = PurchaseOrderTransformer.fetchCollection(response.data)
      return data
    })
    .catch((error) => {
      const response = error.response
      if (response && response.status !== 404) {
        throw error
      } 
    })


// WEBPACK FOOTER //
// ./src/services/purchase/fetchPurchaseOrdersWithoutFreight.js